module.exports = __webpack_public_path__ + "static/media/kyllinger.86f7a63c.mp3";